// extracted by mini-css-extract-plugin
module.exports = {"monospace":"countdown_monospace__xFXcU","text-center":"countdown_text-center__3tMmH","text-right":"countdown_text-right__LW2Go","text-left":"countdown_text-left__2UKmF"};